import React from 'react';
import { FormattedMessage } from 'react-intl';

function TableHead(props) {
  return (
    <thead className="thead-light">
      <tr>
        <th
          className="order-id"
          data-sort="order-id"
          scope="col"
          onClick={() => props.applySort('id')}
        >
          <FormattedMessage id="components.pages.management.manageOrders.table.order_nr" />
        </th>
        <th
          className="created_at"
          data-sort="created_at"
          scope="col"
          onClick={() => props.applySort('created_at')}
        >
          <FormattedMessage id="components.pages.management.manageOrders.table.created_at" />
        </th>
        <th
          className="neo-id"
          data-sort="neo-id"
          scope="col"
          onClick={() => props.applySort('neo_id')}
        >
          <FormattedMessage id="components.pages.management.manageOrders.table.neo_id" />
        </th>
        <th
          className="neo-invoice-series"
          data-sort="neo-invoice-series"
          scope="col"
          onClick={() => props.applySort('neo_invoice_series')}
        >
          <FormattedMessage id="components.pages.management.manageOrders.table.neo_invoice_series" />
        </th>
        <th
          className="neo-invoice-number"
          data-sort="neo-invoice-number"
          scope="col"
          onClick={() => props.applySort('neo_invoice_number')}
        >
          <FormattedMessage id="components.pages.management.manageOrders.table.neo_invoice_number" />
        </th>
        {props.shouldRenderFields ?
          <th
            className="user-name"
            data-sort="user-name-id"
            scope="col"
            onClick={() => props.applySort('user_initials')}
          >
            <FormattedMessage id="components.pages.management.manageOrders.table.user-name" />
          </th> :
          null
        }
        <th
          className="organization-name"
        >
          <FormattedMessage id="pages.documents.documentList.document_organization_id_col" />
        </th>
        <th
          className="order-status"
          data-sort="order-status"
          scope="col"
          onClick={() => props.applySort('status')}
        >
          <FormattedMessage id="components.pages.management.manageOrders.table.status" />
        </th>
        <th scope="col">
          <FormattedMessage id="fields.order_type" />
        </th>
        <th>
          <FormattedMessage id="components.pages.management.manageOrders.table.refunded_order_number" />
        </th>
        <th
          className="order-total"
          data-sort="order-total"
          scope="col"
          onClick={() => props.applySort('total')}
        >
          <FormattedMessage id="components.pages.management.manageOrders.table.total" />
        </th>
        <th
          scope="row"
          className="w-10"
        >
          <FormattedMessage id="components.pages.management.manageOrders.table.actions" />
        </th>
      </tr>
    </thead>
  )
}

export { TableHead };
